import axios from 'axios';
import { settings } from '../config';
export async function getTasks(type: string, provider?: string) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = `${settings.url}tasks/${type}`;
    const response = provider
      ? await axios.get(url, { ...config, params: { provider: provider } })
      : await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function recordTaskProgress(
  type: string,
  id: number,
  provider: string,
) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = `${settings.url}tasks/${type}/record/${id}`;
    const response = await axios.post(url, { provider: provider }, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function claimTask(
  type: string,
  id: number | string,
  provider?: string,
) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = provider
      ? `${settings.url}tasks/${type}/reward/${id}?provider=${provider}`
      : `${settings.url}tasks/${type}/reward/${id}`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
